var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPngIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7022 46.9214H12.9719C9.99329 46.9214 7.57865 44.5067 7.57865 41.5281V6.47191C7.57865 3.49329 9.9933 1.07865 12.9719 1.07865H27.3457L42.0955 16.343V41.5281C42.0955 44.5067 39.6809 46.9214 36.7022 46.9214Z",
    fill: "#EEF1F7",
    stroke: "#CBD0DC",
    strokeWidth: 2.1573
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1738 20H38.7738V40.4H10.1738V20Z",
    fill: "#98D0F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5732 40.3999H38.7732V29.3999C38.7732 29.3999 27.5732 31.1999 23.5732 40.3999Z",
    fill: "#648C3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1738 28.5V40.5H34.2738C24.6738 28.7 10.1738 28.5 10.1738 28.5Z",
    fill: "#88C057"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9734 29.6C28.7407 29.6 30.1734 28.1673 30.1734 26.4C30.1734 24.6326 28.7407 23.2 26.9734 23.2C25.2061 23.2 23.7734 24.6326 23.7734 26.4C23.7734 28.1673 25.2061 29.6 26.9734 29.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngIcon);
export default __webpack_public_path__ + "static/media/png_icon.91e1cc389e3bf43acb1bceace7ba20d9.svg";
export { ForwardRef as ReactComponent };